<template>
  <div class="text-center">
    <h1>Page not found</h1>
    <div><router-link :to="{name: 'overview'}">Return to dashboard</router-link></div>
  </div>
</template>

<script>
export default {
  name: "NotFound"
}
</script>

<style scoped>

</style>